  import { Injectable } from '@angular/core';
 import { CanActivate, Router } from '@angular/router';
 
 @Injectable({
   providedIn: 'root'
 })
 export class AdminOperaterGuard implements CanActivate {
 
   constructor(private router: Router) {}
 
   canActivate(): boolean {
     const user = JSON.parse(localStorage.getItem('loggedUser'));
 
     if (!user) {
       this.router.navigate(['/admin/login']);
       return false;
     }
 
     
     if (user.role === 'Admin'  || user.role === 'Operater' || user.role === 'Manager') {
       return true;
     } 
    
     this.router.navigate(['/admin/login']);
     return false;
   }
 }